import IInitializableModule from '@episerver/spa-core/Core/IInitializableModule';
import IServiceContainer from '@episerver/spa-core/Core/IServiceContainer';
import IEpiserverContext from '@episerver/spa-core/Core/IEpiserverContext';
import IStateReducerInfo from '@episerver/spa-core/Core/IStateReducerInfo';
import dwhReportManagementReducer from './dwhSlice';

export default class DwhReportManagementInitializableModule implements IInitializableModule {
  protected name: string = 'dwh report management module';

  public GetName(): string {
    return this.name;
  }

  public ConfigureContainer(container: IServiceContainer): void {
    // No container configuration needed for now
  }

  public StartModule(context: IEpiserverContext): void {
    // No startup logic needed for now
  }

  public GetStateReducer(): IStateReducerInfo<any> | null {
    return {
      stateKey: 'dwhReportManagement',
      reducer: dwhReportManagementReducer,
    };
  }
}
